// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2V0LQ","paramInput":"JobSimulator_paramInput__3pxQY","input":"JobSimulator_input__2AqvM"};